module.exports = __webpack_public_path__ + "static/press_release.66ed079f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/press_release.pdf
// module id = 346
// module chunks = 35783957827783